import React, {useContext} from "react";
import {Button, Table} from "react-bootstrap";
import editIcon from "../../styles/assets/icons/edit.svg";
import trashIcon from "../../styles/assets/icons/trash.svg";
import {fetchPromises} from "../../core/utils/fetchPromises";
import {APIClient} from "../../core/utils/APIClient";
import {ConfirmModalContext} from "../modal/ConfirmModalProvider.js";
import TablePagination from "../table/TablePagination";
import {withRouter} from "react-router-dom";
import {ENUM} from "../../core/utils/enum.js";

function ArticlesTable(props) {
    const {showConfirmModal} = useContext(ConfirmModalContext);

    const onDeleteClick = async (event) => {
        const id = +event.currentTarget.dataset.id;
        showConfirmModal("Are you sure to delete article?", async () => {
            try {
                await APIClient().deleteArticle(id);
                props.refresh();
            } catch (e) {}
        });
    }

    const onPageChange = async (page) => {
        props.history.push({
            pathname: `/${ENUM.route.admin}/${ENUM.route.articles}`,
            search: "?" + new URLSearchParams({
                ...props.filter,
                page
            }).toString()
        });
    }

    return (
        <>
            <div className="page-content">
                <Table hover className="mb-0 table-va-middle">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Brand</th>
                        <th>Category</th>
                        <th className="text-end">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {props.articles && props.articles.articles.map((a, index) =>
                        <tr key={index}>
                            <td>{a.name}</td>
                            <td>{a.brandName}</td>
                            <td>{a.categoryName}</td>
                            <td className="text-end table-actions">
                                <Button
                                    className="me-2"
                                    size="sm"
                                    variant="outline-primary"
                                    onClick={props.onEditClick}
                                    data-id={a.id}
                                >
                                    <img src={editIcon} alt="edit" className="d-block" />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={onDeleteClick}
                                    data-id={a.id}
                                >
                                    <img src={trashIcon} alt="delete" className="d-block" />
                                </Button>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
                currentPage={props.filter.page ? +props.filter.page : 1}
                totalCount={props.articles.count}
                pageSize={props.articles.rowsPerPage}
                onPageChange={onPageChange}
            />
        </>
    );
}
export default withRouter(
    fetchPromises({
        articles: () => ({ name: 'getArticles', props: ['filter'] }),
    })(ArticlesTable)
);
